import adaptATGBasketErrorMessage from 'services/basket/adaptors/adaptATGBasketErrorMessage';

import {
  isATGBasketErrorResponse,
  isODMBasketErrorResponse,
  isSkyscapeBasketErrorResponse,
} from 'utilities/basket/basketUtilities';

import { DEFAULT_BASKET_ERROR_MESSAGE } from 'constants/basket';

import {
  ATGBasketResponse,
  BasketResponse,
  ODMBasketResponse,
  SkyscapeBasketResponse,
} from '../../../types/BasketTypes';

const adaptBasketResponse = (
  response: (ATGBasketResponse | SkyscapeBasketResponse | ODMBasketResponse) & {
    status: number;
    statusText?: string;
    ok?: boolean;
  },
): BasketResponse => {
  if (isATGBasketErrorResponse(response)) {
    return {
      message: adaptATGBasketErrorMessage(response.formExceptions[0].errorCode) || DEFAULT_BASKET_ERROR_MESSAGE,
      status: response.status,
      statusText: response.statusText || '',
      success: false,
    };
  }

  if (isSkyscapeBasketErrorResponse(response)) {
    return {
      message: response.errors[0].errors[0] || DEFAULT_BASKET_ERROR_MESSAGE,
      status: response.status,
      statusText: response.statusText || '',
      success: false,
    };
  }

  if (isODMBasketErrorResponse(response)) {
    return {
      message: response.error.errors[0].errors[0] || DEFAULT_BASKET_ERROR_MESSAGE,
      status: response.status,
      statusText: response.statusText || '',
      success: false,
    };
  }

  if ((response.ok !== undefined && !response.ok) || response.status < 200 || response.status >= 300) {
    return {
      message: DEFAULT_BASKET_ERROR_MESSAGE,
      status: response.status,
      statusText: response.statusText || '',
      success: false,
    };
  }

  return {
    message: '',
    status: 200,
    statusText: 'OK',
    success: true,
  };
};

export default adaptBasketResponse;
